import React, { Fragment, useState, useEffect } from "react";
import { Button, Container } from "reactstrap";
import { useParams }  from "react-router-dom";
import { Link } from "react-router-dom";

import Loader from "~/components/loader"
import HCaptcha from '@hcaptcha/react-hcaptcha';
import Promotion from "~/services/promotions";


const PromoPage = ({})=> {

  const key = process.env.REACT_APP_HCAPTCHA_KEY;

  const [points    , setPoints]  = useState(null);
  const [isLoading , setLoading] = useState(true);
  const [isClaimed , setClaimed] = useState(null);
  const [isExpired , setExpired] = useState(null);
  const [errors    , setErrors]  = useState(null);

  const params = useParams();

  useEffect(()=> {
    (async ()=> {
      const payload = {code: params.code};
      Promotion.find(payload).then((response)=> {
        setClaimed(response.isClaimed);
        setExpired(response.isExpired);
      }).catch(setErrors)
        .finally(()=> {
          setLoading(false);
        });
    })();
  }, []);

  const handleVerificationSuccess = (token)=> {

    setLoading(true);
    let payload = {code: params.code, token};

    Promotion.claim(payload)
      .then(setPoints)
      .catch(setErrors)
      .finally(()=> setLoading(false));
  };

  return (
    <Container fluid={true} className="promo-page">
      <h1 className="main-title"> Promo </h1>

      <div className="text-center m-t-50">
        { isLoading && <Loader type={19} center /> }
        { isClaimed &&
          <Fragment>
            <h5 className="claimed m-b-40">Promotion already claimed! </h5>
            <p>
              Do you know to earn even more points easily? <br/>
              Check out our surveys section and you can <strong>earn up to 10.000 points</strong> for each completed survey!
            </p>
            <Link className="btn" to={"/surveys"} > <Button className="go-to-survey" color="pitch">Go to Surveys</Button> </Link>
          </Fragment>
        }
        { isExpired && isClaimed === false && <div>
          <h3 className="text-danger m-b-30"> Sorry! :( </h3>
          <h5 className="failed">You are too late, this offer is expired!</h5>
          <p>Turn on notifications for our <a href="https://telegram.me/earndorado" target="_blank"> Telegram channel</a>  and don't miss the next giveaway.</p>
          <hr/>
          <p>
            Do you know to earn even more points easily? <br/>
            Check out our surveys section and you can <strong>earn up to 10.000 points</strong> for each completed survey!
          </p>
          <Link className="btn btn-success go-to-survey " to={"/surveys"} > Go to Surveys </Link>
        </div> }
        { errors && <div>
          <h3 className="text-danger m-b-30"> Sorry! :( </h3>
          <h5 className="failed">{ errors.data ? errors.data.error : errors.generalError }</h5>
          <p>Turn on notifications for our <a href="https://telegram.me/earndorado" target="_blank"> Telegram channel</a>  and don't miss the next giveaway.</p>
        </div>  }
        { (isClaimed === false) && (isExpired === false) && (isLoading === false) && !points && !errors && (
          <Fragment>
            <p> Complete the captcha and claim your reward! </p>
            <HCaptcha sitekey={key} onVerify={handleVerificationSuccess} />
          </Fragment>
        )}

        { points &&
          <Fragment>
            <h5 className="text-success m-b-40">Congratulations!! You claimed {points} points!</h5>
            <p>
              Do you know to earn even more points easily? <br/>
              Check out our surveys section and you can <strong>earn up to 10.000 points</strong> for each completed survey!
            </p>
            <Link className="btn" to={"/surveys"} > <Button className="go-to-survey" color="pitch">Go to Surveys</Button> </Link>
          </Fragment>
        }
      </div>
    </Container>
  );
}

export default PromoPage;
